<template>
  <router-link
    v-if="mainLink"
    class="text-decoration-none"
    :to="{ name: 'main' }"
    id="btn__vkf+qv84b0ejYR2PjQ8weA=="
  >
    <p class="logo__text" :class="bindClass" :style="fontSize">#BUY NOW</p>
    <!-- <v-btn @click="test">테스트</v-btn> -->
  </router-link>
  <p v-else class="logo__text" :class="bindClass" :style="fontSize">
    #BUY NOW
    <!-- <v-btn @click="test">테스트</v-btn> -->
  </p>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    size: {
      type: String,
      default: '28px',
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
    white: {
      type: Boolean,
      default: false,
    },
    mainLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('device', ['info']),
    fontSize() {
      const size = this.size
      return {
        fontSize: size + '!important',
        fontWeight: '900 !important',
      }
    },
    bindClass() {
      let color = ['color--buynow']
      if (this.white) {
        color = ['color--white']
      }
      return [...this.classes, ...color, 'my-0']
    },
  },
  methods: {
    test() {
      this.$swal.basic.alert(JSON.stringify(this.info))
    },
  },
}
</script>

<style lang="scss" scoped>
.logo__text {
  line-height: 1;
}
</style>
